import { e as d } from "../shared/effect-init.mjs";
import { e as p } from "../shared/effect-target.mjs";
import { e as E } from "../shared/effect-virtual-transition-end.mjs";
import { g as T } from "../shared/utils.mjs";
function P(l) {
  let {
    swiper: e,
    extendParams: n,
    on: c
  } = l;
  n({
    fadeEffect: {
      crossFade: !1
    }
  }), d({
    effect: "fade",
    swiper: e,
    on: c,
    setTranslate: () => {
      const {
        slides: t
      } = e, a = e.params.fadeEffect;
      for (let s = 0; s < t.length; s += 1) {
        const r = e.slides[s];
        let o = -r.swiperSlideOffset;
        e.params.virtualTranslate || (o -= e.translate);
        let f = 0;
        e.isHorizontal() || (f = o, o = 0);
        const m = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(r.progress), 0) : 1 + Math.min(Math.max(r.progress, -1), 0), i = p(a, r);
        i.style.opacity = m, i.style.transform = `translate3d(${o}px, ${f}px, 0px)`;
      }
    },
    setTransition: (t) => {
      const a = e.slides.map((s) => T(s));
      a.forEach((s) => {
        s.style.transitionDuration = `${t}ms`;
      }), E({
        swiper: e,
        duration: t,
        transformElements: a,
        allSlides: !0
      });
    },
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
export {
  P as default
};
//# sourceMappingURL=effect-fade.mjs.map
